import { render, staticRenderFns } from "./EnterSchool.vue?vue&type=template&id=371c340b&"
import script from "./EnterSchool.vue?vue&type=script&lang=ts&"
export * from "./EnterSchool.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports